import { useEffect, useState } from 'react';
import { fetchMedia, fetchPosts } from '../api';
import { Post } from './types';

export const useBlogPosts = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [media, setMedia] = useState<{ [key: number]: string }>({});
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getPosts = async () => {
      if (!loading) {
        return;
      }

      try {
        const postsData = await fetchPosts();
        setPosts(postsData);

        const mediaData: { [key: number]: string } = {};
        await Promise.all(
          postsData?.map(async (post: Post) => {
            const mediaItem = await fetchMedia(post.featured_media);
            mediaData[post.id] = mediaItem.source_url;
          }),
        );

        setMedia(mediaData);
        setLoading(false);
      } catch (e) {
        console.error('Failed to load posts', e);
        setLoading(false);
      }
    };

    getPosts();
  }, []);

  return { posts, media, loading };
};
